import { Routes } from "@angular/router";

export const NEWSROOM_ROUTES: Routes = [
  {
    path: "",
    loadComponent: () =>
      import("./pages/newsroom.component").then((m) => m.NewsroomComponent),
  },
];
